// src/pages/AdminDashboard.js

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  const { currentUser } = useAuth();

  return (
    <div className="legal-container">
      <h1>Painel do Administrador (PTS DEV)</h1>
      <p>Bem-vindo, <strong>{currentUser?.displayName || 'Diretoria'}</strong>!</p>
      
      <p>Esta é a sua área de comando. Escolha o módulo que deseja acessar:</p>
      
      <div style={{ marginTop: '20px' }}>
        <h3>⚙️ Máquina de Vendas & Outbound</h3>
        <ul>
          {/* Aqui ficará a tela onde você sobe o CSV da Receita e acompanha os disparos */}
          <li><Link to="/admin/prospeccao">Gestão de Leads B2B (Receita Federal)</Link></li>
        </ul>

        <h3>💰 Financeiro</h3>
        <ul>
          <li><Link to="/admin/financeiro/cobranca-pix">Gerador de Cobrança PIX</Link></li>
        </ul>

        <h3>📝 Conteúdo e Marketing</h3>
        <ul>
          <li><Link to="/admin/posts">Gerenciador de Blog (Posts)</Link></li>
          <li><Link to="/admin/categorias">Categorias do Blog</Link></li>
          <li><Link to="/admin/autores">Autores</Link></li>
          <Link to="/admin/prospeccao">Prospecção Certificado Digital</Link>
        </ul>

        <h3>👥 Administração</h3>
        <ul>
          <li><Link to="/admin/users">Gerenciador de Usuários</Link> (funcionalidade futura)</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminDashboard;